import React, { useState } from "react";

const NODES = [
  { name: "Charlotte", x: 210, y: 195, hub: true },
  { name: "Matthews", x: 300, y: 250 },
  { name: "Indian Trail", x: 360, y: 285 },
  { name: "Wesley Chapel", x: 400, y: 340 },
  { name: "Weddington", x: 305, y: 335 },
  { name: "Marvin", x: 235, y: 375 },
  { name: "Waxhaw", x: 300, y: 415 },
];

export const StylizedMap = () => {
  const [active, setActive] = useState("Charlotte");
  return (
    <div className="relative w-full" data-testid="stylized-map">
      <svg viewBox="0 0 520 480" className="w-full h-auto" role="img" aria-label="Charlotte-area markets map">
        <defs>
          <pattern id="grid" width="26" height="26" patternUnits="userSpaceOnUse">
            <path d="M26 0 L0 0 0 26" fill="none" stroke="#0D2E1B" strokeWidth="0.4" opacity="0.12" />
          </pattern>
        </defs>

        <rect x="0" y="0" width="520" height="480" fill="url(#grid)" />

        {/* Abstract Mecklenburg region */}
        <path
          d="M70 90 L280 70 L300 210 L250 300 L120 320 L60 210 Z"
          fill="#0D2E1B"
          opacity="0.05"
          stroke="#0D2E1B"
          strokeWidth="1"
          strokeOpacity="0.25"
          strokeDasharray="4 4"
        />
        {/* Abstract Union region */}
        <path
          d="M250 300 L300 210 L470 250 L460 420 L280 440 L230 380 Z"
          fill="#C9A875"
          opacity="0.06"
          stroke="#C9A875"
          strokeWidth="1"
          strokeOpacity="0.4"
          strokeDasharray="4 4"
        />

        <text x="130" y="180" className="font-sans" fill="#0D2E1B" fontSize="12" fontWeight="700" opacity="0.5" letterSpacing="2">
          MECKLENBURG
        </text>
        <text x="330" y="360" className="font-sans" fill="#0D2E1B" fontSize="12" fontWeight="700" opacity="0.5" letterSpacing="2">
          UNION
        </text>

        {/* Connecting lines from hub */}
        {NODES.filter((n) => !n.hub).map((n) => {
          const hub = NODES[0];
          return (
            <line
              key={n.name}
              x1={hub.x}
              y1={hub.y}
              x2={n.x}
              y2={n.y}
              stroke="#C9A875"
              strokeWidth={active === n.name ? 1.6 : 0.8}
              strokeOpacity={active === n.name ? 0.9 : 0.35}
              className="transition-all duration-300"
            />
          );
        })}

        {/* Nodes */}
        {NODES.map((n) => {
          const isActive = active === n.name;
          return (
            <g
              key={n.name}
              onMouseEnter={() => setActive(n.name)}
              className="cursor-pointer"
              data-testid={`map-node-${n.name.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {n.hub && (
                <circle cx={n.x} cy={n.y} r={isActive ? 20 : 16} fill="#0D2E1B" opacity="0.08" className="transition-all duration-300" />
              )}
              <circle
                cx={n.x}
                cy={n.y}
                r={n.hub ? 8 : isActive ? 7 : 5}
                fill={n.hub || isActive ? "#C9A875" : "#0D2E1B"}
                stroke="#FAFAF8"
                strokeWidth="2"
                className="transition-all duration-300"
              />
              <text
                x={n.x + 12}
                y={n.y + 4}
                fill="#1C221F"
                fontSize={n.hub ? 15 : 12}
                fontWeight={n.hub || isActive ? 700 : 500}
                className="font-sans transition-all duration-300"
              >
                {n.name}
              </text>
            </g>
          );
        })}
      </svg>
    </div>
  );
};

export default StylizedMap;
